module.exports = __webpack_public_path__ + "img/kefu.6bbc6e2e.png";